import { render } from "./OrdersManagerStockStandardStage.vue?vue&type=template&id=38827a3a"
import script from "./OrdersManagerStockStandardStage.vue?vue&type=script&lang=js"
export * from "./OrdersManagerStockStandardStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__